import React, { Component } from 'react';
import Testing from './components/sections/Testing';
import Header from './components/header';
import CasesByNumbers from './components/sections/CasesByNumbers';
import Hospitalizations from './components/sections/Hospitalizations';

class Genpop extends Component {
  render() {
    const lang = this.props.lang,
      momentBuildTime = this.props.momentBuildTime;

    return (
      <>
        <Header lang={lang} lastUpdated={momentBuildTime} />

        <CasesByNumbers lang={lang} lastUpdated={momentBuildTime} />

        <Testing lang={lang} lastUpdated={momentBuildTime} />

        <Hospitalizations lang={lang} lastUpdated={momentBuildTime} />
      </>
    );
  }
}

export default Genpop;
